function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import Button from 'components/Form/Button';
import Results from 'svg/results.svg';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './MyResultsBtn.pcss';
var _React_PureComponent;
class MyResultsBtn extends (_React_PureComponent = React.PureComponent) {
    renderAvatar() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.avatar,
            children: /*#__PURE__*/ _jsx(Results, {
                className: styles.avatar__icon
            })
        });
    }
    renderButtonContent() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row align-items-center w-100",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: this.renderAvatar()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: styles.label,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.myResults))
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Button, {
            type: "link",
            to: this.context.getUrl('my-results'),
            styleModifier: this.props.styleModifier,
            className: cn(styles.root, this.props.className),
            onClick: this.props.onOpenModal,
            children: this.renderButtonContent()
        });
    }
}
_define_property(MyResultsBtn, "contextType", AppContext);
_define_property(MyResultsBtn, "propTypes", {
    // Explicit props
    styleModifier: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit props
    activeProfile: PropTypes.shape({
        avatar: PropTypes.string
    }),
    // Implicit actions
    onOpenModal: PropTypes.func
});
_define_property(MyResultsBtn, "defaultProps", {
    styleModifier: 'quinary',
    className: 'btn--block btn--filled m-0'
});
const mapStateToProps = (state)=>({
        activeProfile: selectors.activeProfile(state)
    });
const ConnectedMyResultsBtn = connect(mapStateToProps)(MyResultsBtn);
export default withStyles(styles)(ConnectedMyResultsBtn);
